import { customElement, property, state } from 'lit/decorators.js';
import { css, html, LitElement } from 'lit';
import { dataBroker } from '../../services/DataBroker';
import Debug from 'debug';
import './pdq-tree-view-item';
import { EMPTY_STRING } from '../../utils';
import { Tree } from '../../flow/tree/common';

const log = Debug('pdq:ui:pdq-tree-view');

@customElement('pdq-tree-view')
export class PdqTreeView extends LitElement {
  private subscriptions = [] as { unsubscribe(): void }[];
  private _source: string = EMPTY_STRING;
  @property({ type: String, attribute: 'source' })
  get source(): string {
    return this._source;
  }
  set source(value: string) {
    this._source = value;
    this.subscriptions.forEach(s => s.unsubscribe());
    console.log('source', value);
    dataBroker.getObservableDataSource(value).then(i => {
      console.log('got source', value, i);
      this.subscriptions = [
        i.subscribe(this.boundTreeChanged)
      ];
    })
  }

  @property({ type: Object, reflect: true }) selectedIndexes = new Set<string>();
  @state()  tree: Tree|undefined;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('selection-changed', (e: CustomEvent) => {
      log(`selection-changed: ${e.detail.id} ${e.detail.selected}`, e.detail);
    })
    this.addEventListener('expand-changed', (e: CustomEvent) => {
      log(`expand-changed: ${e.detail.id} ${e.detail.selected}`, e.detail);
    })
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.subscriptions.forEach(s => s.unsubscribe());
  }
  static styles = css` 
      * {
          box-sizing: border-box;
          display: block;
      }
      ul, li {
          list-style-type: none;
          margin: 0;
          padding: 0;
      }
  `;
  render() {
    log('render!');

    if (!this.tree) {
      return html`Error: tree not set`;
    }
    return html`${
      [...this.tree.rootNodes.values()]
      .map((i, idx) =>
        html`<ul role="tree">
        <pdq-tree-view-item
        .node=${i}
        .tree=${this}
        .depth="1" 
      ></pdq-tree-view-item></ul>`)
    }`;
  }
  select(id: string) {
    log('tree select', id);

    this.tree?.toggleSelection(this.tree?.treeMap.get(id));

    // if (!this.multiple)
    //   this.selectedIndexes.clear();
    // this.selectedIndexes.has(id)
    //   ? this.selectedIndexes.delete(id)
    //   : this.selectedIndexes.add(id);
    // this.requestUpdate(`selectedIndexes`);
    this.dispatchEvent(new CustomEvent('selection-changed', {
      detail: {
        id,
        hierarchy: this.tree?.treeMap.get(id)?.hierarchy,
        selected: this.selectedIndexes.has(id),
        multiple: this.tree?.multiple
      }
    }));
    //dataBroker.setDataSource(`${this.id}-selected`, Array.from(this.selectedIndexes));
  }
  boundTreeChanged = this.treeChanged.bind(this);
  treeChanged(tree: Tree){
    console.log('source treeChanged', tree);
    if (!(tree instanceof Tree)) {
      log(`treeChanged: invalid tree`);
      console.error('invalid tree', tree);
      return;
    }
    const oldTree = this.tree
    this.tree = tree
    this.requestUpdate('tree', oldTree)
  }

}